// extracted by mini-css-extract-plugin
var _1 = "_home-module__container";
var _2 = "_home-module__expiry-text";
var _3 = "_home-module__page-header-container";
var _4 = "_home-module__page-title";
var _5 = "_home-module__right-container";
var _6 = "_home-module__subcontainer";
var _7 = "_home-module__tab-display";
export { _1 as "container", _2 as "expiry-text", _3 as "page-header-container", _4 as "page-title", _5 as "right-container", _6 as "subcontainer", _7 as "tab-display" }
